import { render, staticRenderFns } from "./WhoUs.vue?vue&type=template&id=728ee538&scoped=true&"
import script from "./WhoUs.vue?vue&type=script&lang=js&"
export * from "./WhoUs.vue?vue&type=script&lang=js&"
import style0 from "./WhoUs.vue?vue&type=style&index=0&id=728ee538&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728ee538",
  null
  
)

export default component.exports